import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { ContentPage } from './content-page.model';

export interface ContentPagesState extends EntityState<ContentPage, string> {
  loading: boolean;
  searchQuery: string;
  filterPublished?: boolean;
  sortField: string;
  sortOrder: 'asc' | 'desc';
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

export function createInitialState(): ContentPagesState {
  return {
    loading: false,
    searchQuery: '',
    filterPublished: undefined,
    sortField: 'createdAt',
    sortOrder: 'desc',
    pagination: {
      page: 1,
      pageSize: 20,
      total: 0,
      totalPages: 0,
    },
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'contentPages', idKey: 'id', resettable: true })
export class ContentPagesStore extends EntityStore<ContentPagesState> {
  constructor() {
    super(createInitialState());
  }

  updatePagination(pagination: Partial<ContentPagesState['pagination']>) {
    this.update(state => ({
      pagination: {
        ...state.pagination,
        ...pagination,
      },
    }));
  }

  setSearchQuery(query: string) {
    this.update({ searchQuery: query });
  }

  setFilterPublished(isPublished?: boolean) {
    this.update({ filterPublished: isPublished });
  }

  setSort(field: string, order: 'asc' | 'desc') {
    this.update({
      sortField: field,
      sortOrder: order,
    });
  }

  setLoading(loading: boolean) {
    this.update({ loading });
  }
}